import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Ban, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export default function Banned() {
    const navigate = useNavigate();

    const handleSignOut = async () => {
        try {
            await supabase.auth.signOut();
            toast.success("Signed out successfully");
            navigate("/");
        } catch (error) {
            toast.error("Error signing out");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-4">
            <Card className="max-w-md w-full border-red-200">
                <CardHeader className="text-center space-y-4">
                    <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                        <Ban className="w-8 h-8 text-red-600" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-red-600">
                        Account Suspended
                    </CardTitle>
                    <CardDescription className="text-base">
                        Your account has been banned from IndieKeys
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="text-center text-sm text-muted-foreground space-y-2">
                        <p>
                            Your account has been suspended due to a violation of our terms of service.
                        </p>
                        <p>
                            If you believe this is a mistake, please contact our support team.
                        </p>
                    </div>

                    <div className="flex flex-col gap-3">
                        <Button
                            onClick={handleSignOut}
                            className="w-full"
                            variant="destructive"
                        >
                            <LogOut className="w-4 h-4 mr-2" />
                            Sign Out
                        </Button>

                        <Button
                            onClick={() => window.open('mailto:contact@indie-keys.com?subject=Account%20Ban%20Appeal', '_blank')}
                            variant="outline"
                            className="w-full"
                        >
                            Contact Support
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
